<template>
  <!-- <div class="account" v-title data-title="合伙人积分"> -->
  <div class="account" v-title data-title="合伙人积分" style="background: #F4F6FA;">
      <div class="box">

          <div class="boxTop">
            <div class="nav">
              <img src="../../assets/images/my-img/esc.png" alt="" @click="esc">
              <div>合伙人积分</div>
            </div>
            <div class="boxTopa">总积分</div>
            <div class="boxTopb">{{user.score}}</div>
            <div class="boxTopc">
              <div class="boxTopca">自由积分 {{user.available_score}}</div>
              <div class="boxTopcb">限制积分 {{user.score_xy}}</div>
              <div class="boxTopcc" @click="zengsong">赠送</div>
            </div>
          </div>

          <div class="boxCon">
            <!-- 标题 -->
            <div class="boxConTop">
              <img src="../../assets/images/my-img/jifen.png" alt="">
            </div>
            <!-- 积分列表 -->
            <div class="list" v-for="(item,index) in list" :key="index">
              <div class="name">{{item.content}}</div>
              <div class="price">
                <div class="time">{{item.create_time}}</div>
                <div class="prices"><span>+</span>{{item.score}}</div>
              </div>
            </div>
            <!-- 底部 -->
            <div class="boxConBtm">  — 没有更多啦 —</div>
          </div>
          
          <div class="popuo" v-show="a == 1">
            <div class="popus">
              <div class="popuos" @click="zengsongs"></div>
              <div class="give">
                <div class="gives">
                  <div class="giveTop"><div class="giveTops">积分赠送</div></div>
                  <div class="phone">
                    <div class="phonel">对方手机号：</div>
                    <div class="phoner"><input type="text" @change="changea"></div>
                  </div>
                  <div class="phone">
                    <div class="phonel">赠送数量：</div>
                    <div class="phoner"><input type="text" @change="changeb"></div>
                  </div>
                  <!-- <div class="phone">
                    <div class="phonel">积分类型：</div>
                    <div class="phoners">
                      <input type="radio" name="自由积分" value="0" v-model="radio" @change="changec"><span>自由积分</span>
                      <input type="radio" name="限制积分" value="1" v-model="radio" style="margin-left: 0.5rem;" @change="changec"><span>限制积分</span>
                    </div>
                  </div> -->
                  <div class="givebtm">请确保对方绑定手机号码再赠送额度</div>
                  <div class="givebot" @click="submit">确认</div>
                </div>
              </div>
            </div>
          </div>
      </div>
  </div>
</template>
<script>
export default {
  data(){
    return{
      user:{},// 用户资产信息
      list:[],// 积分列表
      a:0,// 赠送积分弹窗
      mobile:"",//赠送对方手机号：
      jifen:"",//赠送积分额度：
      leixing:"",//赠送积分类型：
      radio:0//默认积分类型：
    }
  },
  created(){
    this.assets()// 用户资产信息
    this.integral()// 积分列表

  },
  beforeCreate(){
    document.querySelector('body').setAttribute('style','background: #F4F6FA')
  },
  methods:{
    // 用户资产信息 函数
    assets(){
      this.uid = JSON.parse(localStorage.getItem("uid"));
      this.$axios.get(this.domain.url+"/api/dcash/index/balance",{
        params:{
          uid : this.uid
        }
      }).then((res) => {
        console.log(res.data.data)
        this.user = res.data.data
      })
    },

    // 积分列表
    integral(){
      this.uid = JSON.parse(localStorage.getItem("uid"));
      this.$axios.get(this.domain.url+"/api/score/index/scorelog",{
        params:{
          type : 3,
          uid : this.uid,
          partner_score_type : 2
        }
      }).then((res) => {
        console.log(res.data.data)
        this.list = res.data.data
      })
    },

    // 返回
    esc(){
      this.$router.push({
        path: '/my'
      })
    },

    // 赠送
    zengsong(){
      this.a = 1
    },

    // 取消赠送
    zengsongs(){
      this.a = 0
    },

    // 赠送人手机号
    changea(e){
      console.log(e.target.value)
      this.mobile = e.target.value
    },

    // 赠送积分额度
    changeb(e){
      console.log(e.target.value)
      this.jifen = e.target.value
    },

    // 赠送积分类型选择
    changec(e){
      console.log(e.target.value)
      this.leixing = e.target.value
    },
    // 确认积分赠送
    submit(){
      console.log(this.mobile)
      console.log(this.jifen)
      this.uid = JSON.parse(localStorage.getItem("uid"));
      this.$axios.post(this.domain.url+"/api/score/index/givingScore",{
        // params:{
          giving_uid : this.mobile,
          uid : this.uid,
          score : this.jifen
        // }
      }).then((res) => {
        console.log(res.data.msg)
        alert(res.data.msg)
        this.a = 0
      })
    }
  }
}
</script>
<style lang="less" scoped>
  // 佣金 积分
  .box{
      width: 100%;
      height: 100%;
      position: relative;
      background: #F4F6FA!important;
      .boxTop{
          width: 100%;
        //   height: 266px;
          height: 5.32rem;
          background: linear-gradient(360deg, rgba(255, 200, 0, 0) 0%, #FFB500 30%, #FF6300 100%);
          overflow: hidden;
          .nav{
            width: 100%;
            height: 0.5rem;
            margin-top: 1.08rem;
            display: flex;
            justify-content: flex-start;
            align-items: center;
            img{
              width: 0.34rem;
              height: 0.34rem;
              margin-left: 0.54rem;
            }
            div{
              margin-left: 1.98rem;
              font-size: 0.36rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
          .boxTopa{
            width: 0.84rem;
            margin: auto;
            margin-top: 0.48rem;
            font-size: 0.28rem;
            font-family: PingFang-SC-Medium, PingFang-SC;
            font-weight: 500;
            color: #FFFFFF;
          }
          .boxTopb{
            margin: auto;
            margin-top: 0.1rem;
            width: 1.84rem;
            font-size: 0.7rem;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #FFFFFF;
          }
          .boxTopc{
            margin: auto;
            margin-top: 0.2rem;
            display: flex;
            justify-content: center;
            align-items: center;
            font-size: 0.26rem;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: #FFFFFF;
            .boxTopca{
              margin-right: 0.3rem;
            }
            .boxTopcc{
              width: 1rem;
              height: 0.48rem;
              margin-left: 0.1rem;
              background: rgba(255, 255, 255, 0.6);
              border-radius: 0.24rem;
              border: 0.02rem solid rgba(255, 99, 0, 0.74);
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.26rem;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #FF6300;
            }
          }
      }
      .boxCon{
          position: absolute;
        //   top: 222px;
          top: 4.44rem;
          left: 4%;
        //   width: 345px;
          width: 92%;
          // height: 3.52px;
          // height: 7.04rem;
          background: #FFFFFF;
        //   border-radius: 8px;
          border-radius: 0.16rem;
          z-index: 99;
          margin-bottom: 4.76rem;
          .boxConTop{
            margin: auto;
            margin-top: 0.38rem;
            margin-bottom: 0.1rem;
            // width: 85px;
            // height: 26px;
            width: 1.7rem;
            height: 0.52rem;
            img{
              width: 100%;
              height: 100%;
            }
            
          }
          .list{
            width: 6.5rem;
            height: 1.4rem;
            margin: auto;
            box-sizing: border-box;
            border-bottom: 0.02rem solid #F4F6FA;
            .name{
              width: 6.3rem;
              height: 0.42rem;
              margin: 0.3rem 0rem 0rem 0.1rem;
              font-size: 0.3rem;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #222222;
            }
            .price{
              width: 6.3rem;
              height: 0.56rem;
              margin-left: 0.1rem;
              .time{
                float: left;
                margin-top: 0.2rem;
                font-size: 0.26rem;
                font-family: PingFang-SC-Regular, PingFang-SC;
                font-weight: 400;
                color: #999999;
              }
              .prices{
                float: right;
                font-size: 0.4rem;
                font-family: PingFangSC-Semibold, PingFang SC;
                font-weight: 600;
                color: #FF6300;
                span{
                  font-size: 0.3rem;
                }
              }
            }
          }
          .boxConBtm{
            width: 2.32rem;
            height: 0.34rem;
            font-size: 0.24rem;
            margin: auto;
            margin-top: 0.3rem;
            margin-bottom: 0.3rem;
            font-family: PingFang-SC-Regular, PingFang-SC;
            font-weight: 400;
            color: #999999;
          }
      }
      .popuo{
        width: 100%;
        height: 100vh;
        position: absolute;
        top: 0rem;
        left: 0rem;
        z-index: 999;
        .popus{
          width: 100%;
          height: 100vh;
          position: relative;
        
        .popuos{
          width: 100%;
          height: 100vh;
          background:rgba(0,0,0,0.4);
        }
        .give{
          width: 6.3rem;
          // height: 5.28rem;
          height: auto;
          background:#FFFFFF;
          border-radius: 0.16rem;
          position: absolute;
          top: 4.76rem;
          left: 0.6rem;
          .gives{
            width: 6.1rem;
            height: 100%;
            margin: auto;
            .giveTop{
              width: 100%;
              height: 1.4rem;
              border-bottom: 0.02rem solid #F4F6FA;
              overflow: hidden;
              .giveTops{
                width: 1.44rem;
                height: 0.5rem;
                font-size: 0.36rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #232326;
                margin: auto;
                margin-top: 0.6rem;
              }
            }
            .phone{
              width: 100%;
              height: 0.6rem;
              margin-top: 0.3rem;
              .phonel{
                font-size: 0.28rem;
                font-family: PingFangSC-Medium, PingFang SC;
                font-weight: 600;
                color: #232326;
                margin-left: 0.2rem;
                float: left;
                margin-top: 0.1rem;
              }
              .phoner{
                width: 3.64rem;
                height: 100%;
                border: 0.02rem solid #F4F6FA;
                float: right;
                margin-right: 0.48rem;
                input{
                  width: 100%;
                  height: 100%;
                  border: none;
                }
              }
              .phoners{
                width: 3.64rem;
                height: 100%;
                float: right;
                margin-right: 0.48rem;
                display: flex;
                justify-content: flex-start;
                align-items: center;
                input{
                  width: 0.3rem;
                  height: 0.3rem;
                  margin-right: 0.1rem;
                }
              }
            }
            .givebtm{
              margin-left: 0.2rem;
              margin-top: 0.3rem;
              font-size: 0.2rem;
              font-family: PingFang-SC-Regular, PingFang-SC;
              font-weight: 400;
              color: #FF6300;
            }
            .givebot{
              width: 3.66rem;
              height: 0.66rem;
              background: #FF6300;
              border-radius: 0.34rem;
              margin: auto;
              margin-top: 0.48rem;
              margin-bottom: 0.34rem;
              display: flex;
              justify-content: center;
              align-items: center;
              font-size: 0.32rem;
              font-family: PingFangSC-Medium, PingFang SC;
              font-weight: 500;
              color: #FFFFFF;
            }
          }
        }
        }
      }
    
  }
</style>